import React, { useEffect, useState } from 'react';
import { Wrapper, Header } from '../forms/Form';
import { popupComponents$ } from '../../supplementary_components/store';
import { SupplementaryFilesListing } from './supplementaryFilesListing';
import { getAttachmentEntityConfig, getEntityAttachments } from './attachmentEntityConfig';
import styles from './attachmentsPopup.module.scss';

export const ENTITY_ATTACHMENTS_POPUP_KIND = 'entityAttachments';

export function openAttachmentsPopup({
    entityType,
    entity,
    titleLabel = '',
    canEdit = false,
    onEntityUpdated,
    popupKind,
    customMaxWidth = '42rem',
}) {
    const config = getAttachmentEntityConfig(entityType);
    const resolvedPopupKind = popupKind ?? config.popupKind;
    const withoutExisting = popupComponents$.getValue().filter(
        (p) => p.popupData?.popupKind !== resolvedPopupKind,
    );
    popupComponents$.next([
        ...withoutExisting,
        {
            content: AttachmentsPopup,
            popupData: {
                popupKind: resolvedPopupKind,
                entityType,
                entityId: entity?.id,
                titleLabel,
                titlePrefix: config.titlePrefix,
                files: getEntityAttachments(entity, entityType),
                canEdit: !!canEdit,
                onEntityUpdated,
            },
            EZCloseAllowed: true,
            customMaxWidth,
            customWidth: '100%',
        },
    ]);
}

export const AttachmentsPopup = ({ popupData }) => {
    const config = getAttachmentEntityConfig(popupData.entityType);
    const titleLabel = popupData?.titleLabel ?? '';
    const [files, setFiles] = useState(popupData?.files);

    useEffect(() => {
        setFiles(popupData?.files);
    }, [popupData?.files]);

    const handleEntityUpdated = (entity) => {
        const updatedFiles = entity?.[config.filesField];
        if (updatedFiles != null) {
            setFiles(updatedFiles);
        }
        popupData?.onEntityUpdated?.(entity);
    };

    return (
        <div className={styles.attachmentsRoot} onClick={(e) => e.stopPropagation()}>
            <Wrapper style={{ width: '100%', maxWidth: '100%' }}>
            <Header>
                <span>
                    {popupData?.titlePrefix ?? 'Attachments'} {titleLabel}
                </span>
            </Header>
            <div className={styles.attachmentsContent}>
                <div className={styles.attachmentsBody}>
                    <SupplementaryFilesListing
                        entityType={popupData.entityType}
                        files={files}
                        entityId={popupData.entityId}
                        canEdit={popupData.canEdit}
                        onEntityUpdated={handleEntityUpdated}
                    />
                </div>
            </div>
            </Wrapper>
        </div>
    );
};
